import React, { useState } from 'react';
import {
  Box,
  Button,
  Stack,
  Fade,
  MobileStepper,
  useTheme,
  useMediaQuery,
} from '@mui/material';
import { KeyboardArrowRight, KeyboardArrowLeft } from '@mui/icons-material';
import TutorialSlide from './TutorialSlide';

const TutorialCarousel = ({ slides, onFinish, onCta }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const [step, setStep] = useState(0);
  const total = slides.length;
  const current = slides[step];

  const isLast = step === total - 1;

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
      <Box sx={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <Fade in key={step} timeout={300}>
          <Box sx={{ width: '100%' }}>
            <TutorialSlide slide={current} onCta={onCta} isMobile={isMobile} />
          </Box>
        </Fade>
      </Box>

      <MobileStepper
        variant="dots"
        steps={total}
        position="static"
        activeStep={step}
        sx={{
          bgcolor: 'transparent',
          justifyContent: 'center',
          '& .MuiMobileStepper-dot': { mx: 0.5 },
          '& .MuiMobileStepper-dotActive': { backgroundColor: current.color },
        }}
        nextButton={null}
        backButton={null}
      />

      <Stack direction="row" spacing={1.5} sx={{ p: 2, justifyContent: 'space-between' }}>
        <Button
          onClick={() => (step > 0 ? setStep(step - 1) : onFinish('skip'))}
          startIcon={step > 0 ? <KeyboardArrowLeft /> : null}
          sx={{ color: 'text.secondary' }}
        >
          {step > 0 ? 'Back' : 'Skip'}
        </Button>
        {isLast ? (
          <Button
            variant="contained"
            onClick={() => onFinish('finish')}
            sx={{ backgroundColor: current.color, '&:hover': { backgroundColor: current.color, opacity: 0.9 } }}
          >
            Get Started
          </Button>
        ) : (
          <Button
            variant="contained"
            onClick={() => setStep(step + 1)}
            endIcon={<KeyboardArrowRight />}
            sx={{ backgroundColor: current.color, '&:hover': { backgroundColor: current.color, opacity: 0.9 } }}
          >
            Next
          </Button>
        )}
      </Stack>
    </Box>
  );
};

export default TutorialCarousel;
